document.addEventListener('DOMContentLoaded', () => {
    // Use MutationObserver to detect dynamically loaded videos
    const observer = new MutationObserver(() => {
        initializeVideos();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });

    // Initialize video attributes
    function initializeVideos() {
        const videos = document.querySelectorAll('.productView-video video');

        videos.forEach(video => {
            if (!video.hasAttribute('data-autoplay-set')) {
                // Set required attributes
                video.setAttribute('autoplay', '');
                video.setAttribute('muted', '');
                video.setAttribute('playsinline', '');
                video.setAttribute('loop', '');

                // Remove unnecessary attributes
                video.removeAttribute('controls');

                // Prevent duplicate processing
                video.setAttribute('data-autoplay-set', 'true');

                // Attempt to play the video
                video.play().catch(error => {
                    console.error('Autoplay failed:', error);
                });
            }
        });
    }

    // Run initialization for already existing videos
    initializeVideos();
});